import DOCXPreview from "./DOCXPreview"

export default DOCXPreview
